import { Component, OnInit, AfterViewInit } from '@angular/core';
import * as Chart from 'chart.js'
@Component({
  selector: 'app-body',
  templateUrl: './body.component.html',
  styleUrls: ['./body.component.scss']
})
export class BodyComponent implements OnInit, AfterViewInit {
  canvas: any;
  ctx: any;
  stats: any; items: any;
  headers: any;
  date: any;
  constructor() { }

  ngOnInit(): void {
    this.stats = {
        daily: [
          {name: 'Daily Transaction Volume', number: 2342},
          {name: 'Daily Transaction Value', number: 4000000},
        ],
        total: [
          {name: 'Total Transaction Volume', number: 452000},
          {name: 'Total Transaction Value', number: 4000000},
        ],
      };
    console.log(this.stats);

    this.date = new Date();
    // Chart configuration
    this.canvas = document.getElementById('myChart');
    new Chart(this.canvas, {
      type: 'line',
      data: {
          labels: ['', '', '', '', '', '', '', '', '', '', '', '','', '', '', '', '', '', '', '', ''],
          datasets: [{
              ///label: '# of Votes',
              data: [120, 160, 200, 149,144, 140, 45,24, 45, 400,120, 120, 93, 150, 28,1, 123, 160, 320, 260, 320],
              backgroundColor: [
                  'rgba(2, 148, 255, 0.45)',
                  'rgba(2, 148, 255, 0.45)',
                  'rgba(2, 148, 255, 0.45)',
                  'rgba(2, 148, 255, 0.45)',
                  'rgba(2, 148, 255, 0.45)',
                  'rgba(2, 148, 255, 0.45)'
              ],
              borderColor: [
                'rgba(2, 148, 255, 0.45)',
                'rgba(2, 148, 255, 0.45)',
                'rgba(2, 148, 255, 0.45)',
                'rgba(2, 148, 255, 0.45)',
                'rgba(2, 148, 255, 0.45)',
                'rgba(2, 148, 255, 0.45)'
              ],
              borderWidth: 1
          }]
      },
      options: {
          scales: {
              yAxes: [{
                  ticks: {
                      beginAtZero: true
                  }
              }]
          }
      }
    });

  }

  ngAfterViewInit(){
  
    // TABLE DATA
    this.items = [
      {type: 'Apple Mac Book 15” 250 SSD 12GB', price: '$73430', ref: '1234567890', time: '12:30', status: 'reconciled'},
      {type: 'Apple Mac Book 15” 250 SSD 12GB', price: '$73430', ref: '1234567890', time: '12:30', status: 'pending'},
      {type: 'Apple Mac Book 15” 250 SSD 12GB', price: '$73430', ref: '1234567890', time: '12:30', status: 'pending'},
      {type: 'Apple Mac Book 15” 250 SSD 12GB', price: '$73430', ref: '1234567890', time: '12:30', status: 'reconciled'},
      {type: 'Apple Mac Book 15” 250 SSD 12GB', price: '$73430', ref: '1234567890', time: '12:30', status: 'reconciled'},
      {type: 'Apple Mac Book 15” 250 SSD 12GB', price: '$73430', ref: '1234567890', time: '12:30', status: 'pending'},
      {type: 'Apple Mac Book 15” 250 SSD 12GB', price: '$73430', ref: '1234567890', time: '12:30', status: 'unreconciled'},
      {type: 'Apple Mac Book 15” 250 SSD 12GB', price: '$73430', ref: '1234567890', time: '12:30', status: 'reconciled'},
      {type: 'Apple Mac Book 15” 250 SSD 12GB', price: '$73430', ref: '1234567890', time: '12:30', status: 'pending'},
      {type: 'Apple Mac Book 15” 250 SSD 12GB', price: '$73430', ref: '1234567890', time: '12:30', status: 'reconciled'},
      {type: 'Apple Mac Book 15” 250 SSD 12GB', price: '$73430', ref: '1234567890', time: '12:30', status: 'pending'},
      {type: 'Apple Mac Book 15” 250 SSD 12GB', price: '$73430', ref: '1234567890', time: '12:30', status: 'reconciled'},
      {type: 'Apple Mac Book 15” 250 SSD 12GB', price: '$73430', ref: '1234567890', time: '12:30', status: 'pending'},
      {type: 'Apple Mac Book 15” 250 SSD 12GB', price: '$73430', ref: '1234567890', time: '12:30', status: 'reconciled'},
      {type: 'Apple Mac Book 15” 250 SSD 12GB', price: '$73430', ref: '1234567890', time: '12:30', status: 'reconciled'},
      {type: 'Apple Mac Book 15” 250 SSD 12GB', price: '$73430', ref: '1234567890', time: '12:30', status: 'unreconciled'},
      {type: 'Apple Mac Book 15” 250 SSD 12GB', price: '$73430', ref: '1234567890', time: '12:30', status: 'pending'},
      {type: 'Apple Mac Book 15” 250 SSD 12GB', price: '$73430', ref: '1234567890', time: '12:30', status: 'pending'}
    ];

    this.headers=[
      "Item Type",
      "Price",
      "Transaction No",
      "Time",
      "Status"
    ];
  }

}
